var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"outer",staticClass:"scroll-outer",on:{"mouseover":_vm.onMouseover,"mouseleave":_vm.onMouseleave}},[_c('div',{ref:"scrollBox",staticClass:"scroll-inner-box"},[_c('div',{ref:"scrollItemBox",staticClass:"scroll-item-box"},[_vm._t("default")],2),(_vm.showSecond)?_c('div',{staticClass:"scroll-item-box"},[_vm._t("default")],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }